module.exports = __webpack_public_path__ + "img/preview-8.35bef3af.png";